/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ApprovalContractDto,
  CompleteSigningRequest,
  ContractDetails,
  ContractDtoPaginatedData,
  ContractTrackingTimelineDto,
  ContractTrackingWorkflowDto,
  CreateContractTrackingRequest,
  GetApprovalContractsParams,
  GetAvailableContractTrackingWorkflowsParams,
  GetContractDetailsParams,
  GetContractTableParams,
  GetContractTrackingWorkflowStepsParams,
  ProfileContract,
  SendNotificationsAndEmailsParams,
  SetDeadlineRequest,
  StartSigningRequest
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetProfileContractsUrl = () => {


  

  return `/api/Contracts/GetProfileContracts`
}

export const getProfileContracts = async ( options?: RequestInit): Promise<ProfileContract[]> => {
  
  return customInstance<ProfileContract[]>(getGetProfileContractsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetProfileContractsQueryKey = () => {
    return [
    `/api/Contracts/GetProfileContracts`
    ] as const;
    }

    
export const getGetProfileContractsQueryOptions = <TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileContractsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileContracts>>> = ({ signal }) => getProfileContracts({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProfileContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileContracts>>>
export type GetProfileContractsQueryError = ErrorType<unknown>


export function useGetProfileContracts<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileContracts>>,
          TError,
          Awaited<ReturnType<typeof getProfileContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProfileContracts<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileContracts>>,
          TError,
          Awaited<ReturnType<typeof getProfileContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProfileContracts<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProfileContracts<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProfileContractsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetProfileContractsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileContractsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileContracts>>> = ({ signal }) => getProfileContracts({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProfileContractsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileContracts>>>
export type GetProfileContractsSuspenseQueryError = ErrorType<unknown>


export function useGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProfileContractsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetContractTableUrl = (params?: GetContractTableParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["departmentTreeNodes","contractTypeTreeNodes","contractStatusIds","personIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetContractTable?${stringifiedParams}` : `/api/Contracts/GetContractTable`
}

export const getContractTable = async (params?: GetContractTableParams, options?: RequestInit): Promise<ContractDtoPaginatedData> => {
  
  return customInstance<ContractDtoPaginatedData>(getGetContractTableUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetContractTableQueryKey = (params?: GetContractTableParams,) => {
    return [
    `/api/Contracts/GetContractTable`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetContractTableQueryOptions = <TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(params?: GetContractTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractTableQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractTable>>> = ({ signal }) => getContractTable(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetContractTableQueryResult = NonNullable<Awaited<ReturnType<typeof getContractTable>>>
export type GetContractTableQueryError = ErrorType<unknown>


export function useGetContractTable<TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(
 params: undefined |  GetContractTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractTable>>,
          TError,
          Awaited<ReturnType<typeof getContractTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractTable<TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(
 params?: GetContractTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractTable>>,
          TError,
          Awaited<ReturnType<typeof getContractTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractTable<TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(
 params?: GetContractTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetContractTable<TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(
 params?: GetContractTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetContractTableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetContractTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(params?: GetContractTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractTableQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractTable>>> = ({ signal }) => getContractTable(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetContractTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getContractTable>>>
export type GetContractTableSuspenseQueryError = ErrorType<unknown>


export function useGetContractTableSuspense<TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(
 params: undefined |  GetContractTableParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractTableSuspense<TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(
 params?: GetContractTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractTableSuspense<TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(
 params?: GetContractTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetContractTableSuspense<TData = Awaited<ReturnType<typeof getContractTable>>, TError = ErrorType<unknown>>(
 params?: GetContractTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetContractTableSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetContractDetailsUrl = (params?: GetContractDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetContractDetails?${stringifiedParams}` : `/api/Contracts/GetContractDetails`
}

export const getContractDetails = async (params?: GetContractDetailsParams, options?: RequestInit): Promise<ContractDetails> => {
  
  return customInstance<ContractDetails>(getGetContractDetailsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetContractDetailsQueryKey = (params?: GetContractDetailsParams,) => {
    return [
    `/api/Contracts/GetContractDetails`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetContractDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(params?: GetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractDetails>>> = ({ signal }) => getContractDetails(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetContractDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getContractDetails>>>
export type GetContractDetailsQueryError = ErrorType<unknown>


export function useGetContractDetails<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params: undefined |  GetContractDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractDetails>>,
          TError,
          Awaited<ReturnType<typeof getContractDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractDetails<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractDetails>>,
          TError,
          Awaited<ReturnType<typeof getContractDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractDetails<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetContractDetails<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetContractDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetContractDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(params?: GetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractDetails>>> = ({ signal }) => getContractDetails(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetContractDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getContractDetails>>>
export type GetContractDetailsSuspenseQueryError = ErrorType<unknown>


export function useGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params: undefined |  GetContractDetailsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetContractDetailsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApprovalContractsUrl = (params?: GetApprovalContractsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetApprovalContracts?${stringifiedParams}` : `/api/Contracts/GetApprovalContracts`
}

export const getApprovalContracts = async (params?: GetApprovalContractsParams, options?: RequestInit): Promise<ApprovalContractDto[]> => {
  
  return customInstance<ApprovalContractDto[]>(getGetApprovalContractsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetApprovalContractsQueryKey = (params?: GetApprovalContractsParams,) => {
    return [
    `/api/Contracts/GetApprovalContracts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApprovalContractsQueryOptions = <TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(params?: GetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalContractsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalContracts>>> = ({ signal }) => getApprovalContracts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApprovalContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalContracts>>>
export type GetApprovalContractsQueryError = ErrorType<unknown>


export function useGetApprovalContracts<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetApprovalContractsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalContracts>>,
          TError,
          Awaited<ReturnType<typeof getApprovalContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApprovalContracts<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalContracts>>,
          TError,
          Awaited<ReturnType<typeof getApprovalContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApprovalContracts<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApprovalContracts<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApprovalContractsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApprovalContractsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(params?: GetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalContractsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalContracts>>> = ({ signal }) => getApprovalContracts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApprovalContractsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalContracts>>>
export type GetApprovalContractsSuspenseQueryError = ErrorType<unknown>


export function useGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetApprovalContractsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApprovalContractsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAvailableContractTrackingWorkflowsUrl = (params: GetAvailableContractTrackingWorkflowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetAvailableContractTrackingWorkflows?${stringifiedParams}` : `/api/Contracts/GetAvailableContractTrackingWorkflows`
}

export const getAvailableContractTrackingWorkflows = async (params: GetAvailableContractTrackingWorkflowsParams, options?: RequestInit): Promise<ContractTrackingWorkflowDto[]> => {
  
  return customInstance<ContractTrackingWorkflowDto[]>(getGetAvailableContractTrackingWorkflowsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAvailableContractTrackingWorkflowsQueryKey = (params?: GetAvailableContractTrackingWorkflowsParams,) => {
    return [
    `/api/Contracts/GetAvailableContractTrackingWorkflows`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAvailableContractTrackingWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableContractTrackingWorkflowsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>> = ({ signal }) => getAvailableContractTrackingWorkflows(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAvailableContractTrackingWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>>
export type GetAvailableContractTrackingWorkflowsQueryError = ErrorType<unknown>


export function useGetAvailableContractTrackingWorkflows<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailableContractTrackingWorkflows<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailableContractTrackingWorkflows<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAvailableContractTrackingWorkflows<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAvailableContractTrackingWorkflowsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAvailableContractTrackingWorkflowsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableContractTrackingWorkflowsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>> = ({ signal }) => getAvailableContractTrackingWorkflows(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAvailableContractTrackingWorkflowsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>>
export type GetAvailableContractTrackingWorkflowsSuspenseQueryError = ErrorType<unknown>


export function useGetAvailableContractTrackingWorkflowsSuspense<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailableContractTrackingWorkflowsSuspense<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailableContractTrackingWorkflowsSuspense<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAvailableContractTrackingWorkflowsSuspense<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAvailableContractTrackingWorkflowsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreateContractTrackingUrl = () => {


  

  return `/api/Contracts/CreateContractTracking`
}

export const createContractTracking = async (createContractTrackingRequest: CreateContractTrackingRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getCreateContractTrackingUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContractTrackingRequest,)
  }
);}




export const getCreateContractTrackingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractTracking>>, TError,{data: BodyType<CreateContractTrackingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createContractTracking>>, TError,{data: BodyType<CreateContractTrackingRequest>}, TContext> => {

const mutationKey = ['createContractTracking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContractTracking>>, {data: BodyType<CreateContractTrackingRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createContractTracking(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateContractTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof createContractTracking>>>
    export type CreateContractTrackingMutationBody = BodyType<CreateContractTrackingRequest>
    export type CreateContractTrackingMutationError = ErrorType<unknown>

    export const useCreateContractTracking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractTracking>>, TError,{data: BodyType<CreateContractTrackingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContractTracking>>,
        TError,
        {data: BodyType<CreateContractTrackingRequest>},
        TContext
      > => {

      const mutationOptions = getCreateContractTrackingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getSendNotificationsAndEmailsUrl = (params: SendNotificationsAndEmailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/SendNotificationsAndEmails?${stringifiedParams}` : `/api/Contracts/SendNotificationsAndEmails`
}

export const sendNotificationsAndEmails = async (params: SendNotificationsAndEmailsParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getSendNotificationsAndEmailsUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSendNotificationsAndEmailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotificationsAndEmails>>, TError,{params: SendNotificationsAndEmailsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendNotificationsAndEmails>>, TError,{params: SendNotificationsAndEmailsParams}, TContext> => {

const mutationKey = ['sendNotificationsAndEmails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendNotificationsAndEmails>>, {params: SendNotificationsAndEmailsParams}> = (props) => {
          const {params} = props ?? {};

          return  sendNotificationsAndEmails(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendNotificationsAndEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof sendNotificationsAndEmails>>>
    
    export type SendNotificationsAndEmailsMutationError = ErrorType<unknown>

    export const useSendNotificationsAndEmails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotificationsAndEmails>>, TError,{params: SendNotificationsAndEmailsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendNotificationsAndEmails>>,
        TError,
        {params: SendNotificationsAndEmailsParams},
        TContext
      > => {

      const mutationOptions = getSendNotificationsAndEmailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetContractTrackingWorkflowStepsUrl = (params: GetContractTrackingWorkflowStepsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetContractTrackingWorkflowSteps?${stringifiedParams}` : `/api/Contracts/GetContractTrackingWorkflowSteps`
}

export const getContractTrackingWorkflowSteps = async (params: GetContractTrackingWorkflowStepsParams, options?: RequestInit): Promise<ContractTrackingTimelineDto[]> => {
  
  return customInstance<ContractTrackingTimelineDto[]>(getGetContractTrackingWorkflowStepsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetContractTrackingWorkflowStepsQueryKey = (params?: GetContractTrackingWorkflowStepsParams,) => {
    return [
    `/api/Contracts/GetContractTrackingWorkflowSteps`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetContractTrackingWorkflowStepsQueryOptions = <TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractTrackingWorkflowStepsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>> = ({ signal }) => getContractTrackingWorkflowSteps(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetContractTrackingWorkflowStepsQueryResult = NonNullable<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>>
export type GetContractTrackingWorkflowStepsQueryError = ErrorType<unknown>


export function useGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>,
          TError,
          Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>,
          TError,
          Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetContractTrackingWorkflowStepsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetContractTrackingWorkflowStepsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractTrackingWorkflowStepsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>> = ({ signal }) => getContractTrackingWorkflowSteps(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetContractTrackingWorkflowStepsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>>
export type GetContractTrackingWorkflowStepsSuspenseQueryError = ErrorType<unknown>


export function useGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetContractTrackingWorkflowStepsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSetDeadlineUrl = () => {


  

  return `/api/Contracts/SetDeadline`
}

export const setDeadline = async (setDeadlineRequest: SetDeadlineRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getSetDeadlineUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setDeadlineRequest,)
  }
);}




export const getSetDeadlineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDeadline>>, TError,{data: BodyType<SetDeadlineRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDeadline>>, TError,{data: BodyType<SetDeadlineRequest>}, TContext> => {

const mutationKey = ['setDeadline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDeadline>>, {data: BodyType<SetDeadlineRequest>}> = (props) => {
          const {data} = props ?? {};

          return  setDeadline(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetDeadlineMutationResult = NonNullable<Awaited<ReturnType<typeof setDeadline>>>
    export type SetDeadlineMutationBody = BodyType<SetDeadlineRequest>
    export type SetDeadlineMutationError = ErrorType<unknown>

    export const useSetDeadline = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDeadline>>, TError,{data: BodyType<SetDeadlineRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDeadline>>,
        TError,
        {data: BodyType<SetDeadlineRequest>},
        TContext
      > => {

      const mutationOptions = getSetDeadlineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getStartSigningUrl = () => {


  

  return `/api/Contracts/StartSigning`
}

export const startSigning = async (startSigningRequest: StartSigningRequest, options?: RequestInit): Promise<string> => {
  
  return customInstance<string>(getStartSigningUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startSigningRequest,)
  }
);}




export const getStartSigningMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSigning>>, TError,{data: BodyType<StartSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startSigning>>, TError,{data: BodyType<StartSigningRequest>}, TContext> => {

const mutationKey = ['startSigning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSigning>>, {data: BodyType<StartSigningRequest>}> = (props) => {
          const {data} = props ?? {};

          return  startSigning(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartSigningMutationResult = NonNullable<Awaited<ReturnType<typeof startSigning>>>
    export type StartSigningMutationBody = BodyType<StartSigningRequest>
    export type StartSigningMutationError = ErrorType<unknown>

    export const useStartSigning = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSigning>>, TError,{data: BodyType<StartSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSigning>>,
        TError,
        {data: BodyType<StartSigningRequest>},
        TContext
      > => {

      const mutationOptions = getStartSigningMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getStartSigningExternalUrl = () => {


  

  return `/api/Contracts/StartSigningExternal`
}

export const startSigningExternal = async (startSigningRequest: StartSigningRequest, options?: RequestInit): Promise<string> => {
  
  return customInstance<string>(getStartSigningExternalUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startSigningRequest,)
  }
);}




export const getStartSigningExternalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSigningExternal>>, TError,{data: BodyType<StartSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startSigningExternal>>, TError,{data: BodyType<StartSigningRequest>}, TContext> => {

const mutationKey = ['startSigningExternal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSigningExternal>>, {data: BodyType<StartSigningRequest>}> = (props) => {
          const {data} = props ?? {};

          return  startSigningExternal(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartSigningExternalMutationResult = NonNullable<Awaited<ReturnType<typeof startSigningExternal>>>
    export type StartSigningExternalMutationBody = BodyType<StartSigningRequest>
    export type StartSigningExternalMutationError = ErrorType<unknown>

    export const useStartSigningExternal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSigningExternal>>, TError,{data: BodyType<StartSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSigningExternal>>,
        TError,
        {data: BodyType<StartSigningRequest>},
        TContext
      > => {

      const mutationOptions = getStartSigningExternalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getCompleteSigningUrl = () => {


  

  return `/api/Contracts/CompleteSigning`
}

export const completeSigning = async (completeSigningRequest: CompleteSigningRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getCompleteSigningUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      completeSigningRequest,)
  }
);}




export const getCompleteSigningMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeSigning>>, TError,{data: BodyType<CompleteSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeSigning>>, TError,{data: BodyType<CompleteSigningRequest>}, TContext> => {

const mutationKey = ['completeSigning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeSigning>>, {data: BodyType<CompleteSigningRequest>}> = (props) => {
          const {data} = props ?? {};

          return  completeSigning(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteSigningMutationResult = NonNullable<Awaited<ReturnType<typeof completeSigning>>>
    export type CompleteSigningMutationBody = BodyType<CompleteSigningRequest>
    export type CompleteSigningMutationError = ErrorType<unknown>

    export const useCompleteSigning = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeSigning>>, TError,{data: BodyType<CompleteSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeSigning>>,
        TError,
        {data: BodyType<CompleteSigningRequest>},
        TContext
      > => {

      const mutationOptions = getCompleteSigningMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUploadContractUrl = () => {


  

  return `/api/Contracts/UploadContract`
}

export const uploadContract = async (uploadContractBody: number, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUploadContractUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      uploadContractBody,)
  }
);}




export const getUploadContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadContract>>, TError,{data: BodyType<number>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadContract>>, TError,{data: BodyType<number>}, TContext> => {

const mutationKey = ['uploadContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadContract>>, {data: BodyType<number>}> = (props) => {
          const {data} = props ?? {};

          return  uploadContract(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadContractMutationResult = NonNullable<Awaited<ReturnType<typeof uploadContract>>>
    export type UploadContractMutationBody = BodyType<number>
    export type UploadContractMutationError = ErrorType<unknown>

    export const useUploadContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadContract>>, TError,{data: BodyType<number>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadContract>>,
        TError,
        {data: BodyType<number>},
        TContext
      > => {

      const mutationOptions = getUploadContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getSendExternalSignatureMailUrl = () => {


  

  return `/api/Contracts/SendExternalSignatureMail`
}

export const sendExternalSignatureMail = async (sendExternalSignatureMailBody: number, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getSendExternalSignatureMailUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendExternalSignatureMailBody,)
  }
);}




export const getSendExternalSignatureMailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendExternalSignatureMail>>, TError,{data: BodyType<number>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendExternalSignatureMail>>, TError,{data: BodyType<number>}, TContext> => {

const mutationKey = ['sendExternalSignatureMail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendExternalSignatureMail>>, {data: BodyType<number>}> = (props) => {
          const {data} = props ?? {};

          return  sendExternalSignatureMail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendExternalSignatureMailMutationResult = NonNullable<Awaited<ReturnType<typeof sendExternalSignatureMail>>>
    export type SendExternalSignatureMailMutationBody = BodyType<number>
    export type SendExternalSignatureMailMutationError = ErrorType<unknown>

    export const useSendExternalSignatureMail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendExternalSignatureMail>>, TError,{data: BodyType<number>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendExternalSignatureMail>>,
        TError,
        {data: BodyType<number>},
        TContext
      > => {

      const mutationOptions = getSendExternalSignatureMailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    